"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const formatFixedNumber_1 = __importDefault(require("./formatFixedNumber"));
const formatCurrency = (amount, decimals = 0) => {
    if ((0, lodash_1.isNil)(amount))
        return 'N/A';
    if (typeof amount === 'string')
        amount = Number(amount);
    const valueAsCurrency = `$${(0, formatFixedNumber_1.default)(Math.abs(amount), decimals)}`;
    if (valueAsCurrency === 'N/A')
        return valueAsCurrency;
    return amount < 0 ? `-${valueAsCurrency}` : valueAsCurrency;
};
exports.default = formatCurrency;
